<!--
 * @Author: hongye
 * @Date: 2020-09-23 13:57:17
 * @LastEditTime: 2021-04-28 11:07:45
 * @Description:
-->
<template>
  <div>
    <h3 class="online_doc_h3" v-show="title">{{$lang(title)}}</h3>
          <el-table v-if='dataList.length' default-expand-all :data="dataList" row-key="name" border style="width: 100%;border-radius: 4px;">
            <el-table-column prop="name" :label="$lang('属性名')" width="220px"></el-table-column>
            <el-table-column prop="type" :label="$lang('属性类型')"></el-table-column>
            <el-table-column prop="require" :label="$lang('是否必填')"></el-table-column>
            <el-table-column prop="normal" :label="($lang('示例'))">
              <template slot-scope="scope">
                <div v-if="scope.row.isHtml" v-html="scope.row.normal"></div>
                <div v-else>{{ $lang(scope.row.normal) }}</div>
              </template>
            </el-table-column>
            <el-table-column prop="describe" :label="$lang('描述')">
              <template slot-scope="scope">
                  <div v-if="scope.row.isHtml" v-html="scope.row.describe"></div>
                  <div v-else>{{ $lang(scope.row.describe) }}</div>
              </template>
            </el-table-column>
          </el-table>
  </div>
</template>

<script>
export default {
    props:{
        title:{
            type:String,
            default:""
        },
        dataList:{
            type:Array,
            default:function(){
                return [];
            }
        }
    }
}
</script>

<style lang="scss" scoped>

  .online_doc_h3 {
    color: #666666;
    font-size: 16px;
    line-height: 32px;
    margin-bottom: 15px;
  }
</style>
